import * as React from 'react';
import { PillToggleGroup } from '../../ui/pill-toggle-group';
import { FilterSection } from './FilterSection';
import { ENROLLMENT_STATUS_OPTIONS } from '../constants';
import { RosterFilters } from './types';

/**
 * Where the member stands relative to the program, as opposed to where they
 * are in the care funnel.
 *
 * New in round 6, assembled from two values that were previously misfiled in
 * Care Coordination: "New" (a signup-recency toggle that had to be ANDed
 * against the funnel because it co-occurs with any stage) and Cancelled (a
 * funnel *stage*, though a cancelled member has left the funnel rather than
 * occupying a position in it). Giving them their own group is what let Care
 * Coordination become a clean single-select — see `CareCoordinationSection`.
 *
 * Single-select, per the team's framework. Worth knowing that the two values
 * aren't strictly mutually exclusive in the data — a member could sign up and
 * cancel inside the same week — so this is a deliberate product simplification
 * rather than something the model guarantees.
 */
export const EnrollmentStatusSection = ({
  filters,
}: {
  filters: RosterFilters;
}) => (
  <FilterSection title="Enrollment Status" subsection>
    <PillToggleGroup
      options={ENROLLMENT_STATUS_OPTIONS}
      selected={filters.enrollment ? [filters.enrollment] : []}
      onChange={filters.onEnrollmentChange}
      multiple={false}
    />
  </FilterSection>
);
